import { render, staticRenderFns } from "./OvertimeRules.vue?vue&type=template&id=3cbf5cae&scoped=true&"
import script from "./OvertimeRules.vue?vue&type=script&lang=js&"
export * from "./OvertimeRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbf5cae",
  null
  
)

export default component.exports